import { Icon as IconComponent, Text, Tooltip, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Pressable, Spinner } from 'native-base';
import React from 'react';

interface ExportButtonProps {
  count?: number;
  isLoading: boolean;
  onPress: () => void;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ count, isLoading, onPress }) => {
  const isDisabled = count === 0;

  const Icon = isLoading ? (
    <Spinner size="sm" color={Color['brand.tertiary.principal']} />
  ) : (
    <IconComponent
      name="Download"
      size="xxs"
      color={isDisabled ? Color['neutral.light'] : Color['brand.tertiary.principal']}
    />
  );

  return (
    <Pressable isDisabled={isLoading} onPress={onPress} p={0} disabled={isDisabled}>
      <Tooltip label="Exportar em Excel" hasArrow placement="bottom right" isDisabled={isDisabled}>
        <HStack justifyContent="flex-end" alignItems="center" space={Spacing['inline.nano']}>
          <Text color={isDisabled ? 'neutral.light' : 'neutral.black'} variant="semibold">
            {count}
          </Text>
          <Text
            color={isDisabled ? 'neutral.light' : 'brand.tertiary.principal'}
            fontSize={Typography['fontsize.xs']}
            variant="bold">
            EXPORTAR
          </Text>
          {Icon}
        </HStack>
      </Tooltip>
    </Pressable>
  );
};
